export const FILTER_TYPE_ACCOMMODATION_TYPES = 'accommodationTypes';
export const FILTER_TYPE_AIRPORTS = 'airports';
export const FILTER_TYPE_DEPARTURE_DATE_FROM = 'departureDateFrom';
export const FILTER_TYPE_DEPARTURE_DATE_TO = 'departureDateTo';
export const FILTER_TYPE_DESTINATIONS_SUMMER = 'summerDestinations';
export const FILTER_TYPE_DESTINATIONS_WINTER = 'winterDestinations';
export const FILTER_TYPE_DURATIONS = 'durations';
export const FILTER_TYPE_EXCURSIONS = 'excursions';
export const FILTER_TYPE_HOST_TYPES = 'hostTypes';
export const FILTER_TYPE_PACKAGE_TYPES = 'packageTypes';
export const FILTER_TYPE_PRICE_RANGE = 'priceRange';
export const FILTER_TYPE_TOUR_GROUPS = 'tourGroups';
export const SEARCH_PARAMS_PAGE = 'page';
